import Bridge from './Bridge'

BS.DOMReady(() => {
	[].forEach.call(document.querySelectorAll('.js-place-edit-replace'), el => new Bridge(el))
})
